export const actionTypes = {
  ADD_ORDER: "ADD_ORDER",
  DELETE_ORDERS: "DELETE_ORDERS",
  OPEN_MODAL: "OPEN_MODAL",
  SELECT_ORDER: "SELECT_ORDER",
  ADD_PRODUCT: "ADD_PRODUCT",
  EDIT_ORDER: "EDIT_ORDER",
  REMOVE_PRODUCT: "REMOVE_PRODUCT",
  EDIT_PRODUCT: "EDIT_PRODUCT",
  SELECT_PRODUCT_KEY_TO_EDIT: "SELECT_PRODUCT_KEY_TO_EDIT",
  SAVE_PRODUCT_KEY_EDIT: "SAVE_PRODUCT_KEY_EDIT",
  CALCULATE_PAYMENT: "CALCULATE_PAYMENT",
  GET_ORDERS: "GET_ORDERS",
  SET_CURRENT_USER: "SET_CURRENT_USER",
};
